export default __webpack_public_path__ + "static/media/Drazgal's Fabled Shield.aff7f7e8.jpg";